// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
/**
 * 2018-09-03  rlair_GET请求使用etag获取缓存数据，提高请求速度
 */

const data = {};
const etags = {};

export default (url = null, options = {headers: {}}) => {
    url = url || options.url; // eslint-disable-line no-param-reassign

    // GET请求使用etag获取缓存数据，提高请求速度
    // if (options.method === 'GET' || !options.method) {
    if ((options.method && options.method.toUpperCase() === 'GET') || !options.method) {
        const etag = etags[url];
        const cachedResponse = data[`${url}${etag}`]; // ensure etag is for url
        if (etag) {
            options.headers['If-None-Match'] = etag;
        }

        return fetch(url, options).
            then((response) => {
                if (response.status === 304) {
                    return cachedResponse.clone();
                }

                if (response.status === 200) {
                    const responseEtag = response.headers.get('Etag');

                    if (responseEtag) {
                        data[`${url}${responseEtag}`] = response.clone();
                        etags[url] = responseEtag;
                    }
                }

                return response;
            });
    }

    // all other requests go straight to fetch
    return Reflect.apply(fetch, undefined, [url, options]); //eslint-disable-line no-undefined
};
